import axios from 'axios';
import { accessToken } from '@alli/frontend-common';

const centralApiHost = process.env.CENTRAL_API; // eslint-disable-line no-undef

export default function requestAccess(clientIdOrSlug, email, reason) {
    const token = accessToken.getValue();
    if (!token) {
        // this should never happen...
        return Promise.reject(new Error('missing access token'));
    }

    const headers = {
        Authorization: token.authorizationHeader(),
        'Content-Type': 'application/json',
    };

    return axios.post(
        `${centralApiHost}/clients/${clientIdOrSlug}/access_requests`,
        { email, reason },
        { headers },
    );
}
